import React from "react";
import flag from "../../../assets/media/icon/flag-back-primary-500.svg";
import key from "../../../assets/media/icon/key-back-primary-500.svg";
import support from "../../../assets/media/icon/support-back-primary-500.svg";
const OurVision = () => {
  return (
    <section className="sectionn | md:py-94px md:px-30px | py-64px px-20px">
      <div className="section-containerr our-vision | m-auto max-w-[1560px]">
        <h1 className="md:mb-48px md:text-3xl | mb-30px text-primart-900 text-2xl font-semibold">
          Our Vision: Simplify, Optimize & Innovate
        </h1>
        <div className="goals-row | flex justify-between gap-32px | sm:flex-row | flex-col">
          <div className="goal | flex flex-col max-w-sm text-left gap-10px">
            <div className="img">
              <img src={flag} alt="" />
            </div>
            <h5 className="m-0 text-lg text-primary-900 font-medium">
              Our vision
            </h5>
            <p className="m-0 text-accent-400">
              Our vision is to provide the best link shortening service on the
              web by simplifying the process of creating shortened links.
            </p>
          </div>
          <div className="goal | flex flex-col max-w-sm text-left gap-10px">
            <div className="img">
              <img src={support} alt="" />
            </div>
            <h5 className="m-0 text-lg text-primary-900 font-medium">
              Constant Innovation
            </h5>
            <p className="m-0 text-accent-400">
              We are committed to providing a high-quality user experience
              support by constantly improving our technology and innovating new
              solutions.
            </p>
          </div>
          <div className="goal | flex flex-col max-w-sm text-left gap-10px">
            <div className="img">
              <img src={key} alt="" />
            </div>
            <h5 className="m-0 text-lg text-primary-900 font-medium">
              Simplicity is Key
            </h5>
            <p className="m-0 text-accent-400">
              Our goal is to make link sharing accessible to everyone by
              allowing them to create shortened links quickly and easily.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
export default OurVision;
